/**
 * 接口域名的管理
 */
import { sysName } from '@/settings'
const base = {
	development: `/${sysName}/dev`,
	production: '/tpis-admin',
}
// export const baseURL = base[import.meta.env.NODE_ENV || 'production']
export const baseURL = base[process.env.NODE_ENV === 'production' ? 'production' : 'development']
export default base
